<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="fancy-graph-align">
    <!-- <div class="vehicle-profile-header">Respiratory Rate(bpm) <span>{{sourceTimestamp}}</span>
        <span>&nbsp;<img alt="Info" matTooltip="Data from " class="h-20px"
                src="../../../../assets/images/info-icon.svg">
        </span>
    </div> -->
    <div class="vehicle-profile-header info-icon-align position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
            <div class="ft-12">{{sourceTimestamp}}</div>
        </div>
        <div class="am-hover-controller position-relative" *ngIf="sensorId"><img alt="Info"
                src="../../../../assets/images/info-circle.svg">
        </div>
        <!--the hover-pop-->

        <div class="will-appear-on-hover bg-for-popout" id="hover-pop-dover1">

            <div class="d-flex">
                Data from {{sensorId}}
            </div>
        </div>
    </div>
    <!--hover pop ends-->

    <!-- graph for body vitals-->
    <div class="the-fancy-graph d-grid align-content-center"
        *ngIf="respiratoryRate?.attributeValue && !isloader && !isError">

        <div class="groove">
            <div class="adjustable-indicator" [style.left.%]="attributeValueMarker">
                <sup class="sup-bg"
                    [ngClass]="{'bg-red': +respiratoryRate?.attributeValue > upperAlertThreshold || +respiratoryRate?.attributeValue < lowerAlertThreshold,
                    'bg-green': +respiratoryRate?.attributeValue <= upperAlertThreshold && +respiratoryRate?.attributeValue >= lowerAlertThreshold}"><span>{{respiratoryRate?.attributeValue}}</span></sup>
            </div>
        </div>
        <div class="bar-club">
            <div class="red-bar"></div>
            <div class="green-bar values-below-the-bar" [attr.data-content1]="lowerAlertThreshold"
                [attr.data-content2]="upperAlertThreshold"></div>
            <div class="red-bar"></div>
        </div>



    </div>
    <div class="no-data-align" *ngIf="isloader || isError || !respiratoryRate?.attributeValue">
        <p>No Data Available</p>
    </div>



    <!-- graph for body vitals-->

</div>